import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PatientPage from "./PatientPage";
import DashboardPage from "./DashboardPage";
import LiveUpdatePage from "./LiveUpdatePage";

const PortalOverview = () => {
  const { t } = useTranslation();
  return (
    <div id="portal-guide">
      <Typography variant="h5" component="h2" gutterBottoma fontWeight={"bold"}>
        4. {t("operating_manual_portal_overview_title")}
      </Typography>
      <PatientPage />
      <DashboardPage />
      <LiveUpdatePage />
    </div>
  );
};

export default PortalOverview;
